export default __webpack_public_path__ + "static/media/typo_home_title.199b4bf3.svg";